module.exports = __webpack_public_path__ + "uPQDIod2JOJYdqZ-K/agent-training-center_navigating_common_challenges.png";